import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("path", {
      className: "polygon",
      d: "M11 11 L11 5 L27 5 L27 21 L21 21",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("rect", {
      className: "polygon",
      x: "5",
      y: "11",
      width: "16",
      height: "16",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("rect", {
      className: "line",
      x: "5",
      y: "11",
      width: "16",
      height: "4"
    })]
  });
});